import { render, staticRenderFns } from "./AffiliateMarketer.vue?vue&type=template&id=3bdecb72"
import script from "./AffiliateMarketer.vue?vue&type=script&lang=js"
export * from "./AffiliateMarketer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports